import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ViewBasePage } from '@shared/pages';
import type { TUser } from '@shared/models';

@Component({
    'selector': 'app-userSettings',
    'templateUrl': './userSettings.page.html',
    'styleUrls': ['./userSettings.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule, RouterModule ]
})
export class UserSettingsPage extends ViewBasePage implements OnInit, OnDestroy {
    public user: TUser;
    public debugMode = false;

    constructor(injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter() {
        super.setCurrentView(this.Constants.VIEW_USER_SETTINGS);
        super.ngOnInit();
        this.user = this.sessionService.getCurrentUser();

        this.initMoreMenu()
    }

    public ionViewWillLeave() {
        super.ngOnDestroy();
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tour', 'show-user-settings-tour');
    }

    public onUserProfileClick(): void {
        this.router.navigateByUrl(`/user/${this.user.uid}`);
    }
}
